import { useEffect, useState } from 'react';
import { matchRoutes } from 'react-router';
import { useLocation } from 'react-router-dom';
import { ROUTES } from './routes';

export const DataPrefetcher = ({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}): JSX.Element => {
  const location = useLocation();
  const [prefetched, setPrefetched] = useState<Array<string>>([]);

  useEffect(() => {
    const match = matchRoutes(ROUTES, location);
    if (!match || match.length === 0) {
      return;
    }

    const { path } = match[0].route;
    const isRouteDataPrefetched = prefetched.includes(path as string);

    if (isRouteDataPrefetched) {
      return;
    }

    const route = ROUTES.find((r) => r.path === path);
    if (!route) {
      return;
    }

    try {
      route.prefetchData();
      setPrefetched([...prefetched, path as string]);
    } catch (e) {
      // Swallow prefetching errors
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return children as JSX.Element;
};
